import {onMounted, onUnmounted, ref} from 'vue';
import api from "@/api/api";
import useTexts from "@/composables/useTexts";

const tents = ref([]);
const tentsLoading = ref(false);
const tentsError = ref(null);
const tentsLoaded = ref( false );

const fitsPlaceSize = (tentSize, placeSize) => {
    const [tentWidth, tentHeight] = tentSize.split('x').map(Number);
    const [placeWidth, placeHeight] = placeSize.split('x').map(Number);
    return (tentWidth <= placeWidth && tentHeight <= placeHeight) ||
        (tentHeight <= placeWidth && tentWidth <= placeHeight);
};

const fitsExactlyPlaceSize = (tentSize, placeSize) => {
    const [tentWidth, tentHeight] = tentSize.split('x').map(Number);
    const [placeWidth, placeHeight] = placeSize.split('x').map(Number);
    // Check if tent dimensions exactly match place dimensions in either orientation
    return (tentWidth === placeWidth && tentHeight === placeHeight) ||
        (tentWidth === placeHeight && tentHeight === placeWidth);
};

const fetchTents = async () => {
    tentsLoading.value = true;
    try {
        const response = await api.get('/tents/');
        tents.value = response.data;
    } catch (error) {
        tentsError.value = 'Error fetching tents: ' + error;
        console.error(tentsError.value);
    } finally {
        tentsLoading.value = false;
    }

};

const useTents = () => {
    let fetchInterval = null;
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent("useTents");

    const startFetching = async () => {
        await fetchTents(); // Immediately fetch when startFetching is called
        tentsLoaded.value = true;
        fetchInterval = setInterval(fetchTents, 30000); // Then fetch every 30 seconds
    };

    onMounted(startFetching);
    onUnmounted(() => {
        clearInterval(fetchInterval);
    });

    const filteredTentsToOptions = (placeSize, excludeNoTent = false) => {
        let result = {};

        result['default'] = { text: `-----` };
        
        if (!excludeNoTent) {
            result[1] = { text: t.value.no_tent};
        }

        tents.value.forEach(curr => {
            if (fitsPlaceSize(curr.size, placeSize)) {
                const floorText = curr.has_floor === "1" ? t.value.with_floor : t.value.without_floor
                let nrOfTentsLeft = curr.available_quantity > 0 ? `(${curr.available_quantity} ${t.value.available})` : `(${t.value.sold_out})`;

                result[curr.id] = {
                    text: `${curr.name} ${curr.size} ${floorText} € ${curr.price} ${nrOfTentsLeft}`,
                    disabled: curr.available_quantity < 1
                };
            }
        });

        return result;
    }


    return { tents, startFetching, filteredTentsToOptions, tentsLoading, tentsError, tentsLoaded, fetchTents, fitsExactlyPlaceSize };
};

export default useTents;
